import React, { FormEvent, useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import EmployeeStore from "../../../app/stores/employeeStore";
import EmployeeCertificateStore from "../../../app/stores/employeecertificateStore";
import { observer } from "mobx-react-lite";
import { Card, Table, Button, Label, Confirm, GridColumn, Grid, Image, Icon, Dimmer, Header, Container, Segment, ButtonGroup, Checkbox, CheckboxProps, Input, Form, Message, List } from "semantic-ui-react";
import { Link } from "react-router-dom";
import CertificatePhotoDropzone from "../../../app/common/Dropzone/CertificatePhotoDropzone";
import { RootStoreContext } from "../../../app/stores/rootStore";
import PhotoView from "../techniciancertificates/PhotoView";
import EmployeeCertificatePhotoView from "./EmployeeCertificatePhotoView";
import EmployeePhotoDropzone from "./EmployeePhotoDropzone";

interface DetailParams {
  id: string;
}

const EmployeeDetails: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {openModal} = rootStore.modalStore;
  const employeeStore = useContext(EmployeeStore);
  const {
    employee,
    loadEmployee,
    loadingInitial,
    loadCertificates,
    loadCertificatesByEmployee,
    employeeCertificatesByDate,
    certificateRegistry,
    employeeCertificateByNameRegistry,
    deleteTechnicianCertificate,
    loadTechnicianCertificatePhoto,
    verifyTechnicianCertificate,
    deleteEmployeePhoto,
    downloadEmployeeCertificateZipFile,
    editEmployeeCertificate,
    changeEmployeeCertificate,
    archiveTechnicianCertificate,
    checkCertificate,
    employeenonecertificatesByName,
    target,
    submitting,
  } = employeeStore;
  const employeecertificateStore = useContext(EmployeeCertificateStore);
  const {    uploadingFile} = employeecertificateStore;

  useEffect(() => {
    loadEmployee(match.params.id);
  }, [loadEmployee, match.params.id]);

  useEffect(() => {
    loadCertificates().then(() => loadCertificatesByEmployee(match.params.id)).then(() => checkCertificate());
  }, []);

  const [open, setOpen] = useState(false);
  const [technicianCertificateId, setTechnicianCertificateId] = useState("");
  const [active, setDimmer] = useState(false);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([] as any);


  if (loadingInitial || !employee)
    return <LoadingComponent content="Loading Employee ..." />;

  if (uploadingFile || employeeStore.uploadingFile)
    return <LoadingComponent content="uploading Photos ..." />;
  
  const handleSelectAll = () => {
      setIsCheckAll(!isCheckAll);
      setIsCheck(employeeCertificatesByDate.map(li => li.id));
      if (isCheckAll) {
        setIsCheck([]);
      }
  };
  
  const handleClick = (id: any, data: CheckboxProps) => {
      setIsCheck([...isCheck, id]);
      if (!data.checked) {
        setIsCheck(isCheck.filter((item: any) => item !== id));
      }
  };

  return (
    <Card fluid>
      <Card.Content>
        {employee.photoUrl !== "" ?
       <Segment floated="right" basic>
       <Dimmer.Dimmable
         dimmed={active}
         onMouseEnter={() => setDimmer(true)}
         onMouseLeave={() => setDimmer(false)}
         >
       <Image
          // floated='right'
          size='small'
          src={employee.photoUrl}
          fluid
        /> 
         <Dimmer active={active}>
               <ButtonGroup vertical size='mini'>
                  <Button
                  as="a"
                    href={employee.photoUrl}
                    download
                    size='mini'
                    content="Download"
                    color="blue"
                  />
                  <Button
                   name={employee.email}
                   size='mini'
                   onClick={() => deleteEmployeePhoto(employee.email)}
                   color="red"
                   content="Delete"
                 />
                 </ButtonGroup>
          </Dimmer> 
        </Dimmer.Dimmable>
        </Segment>
        :
        <Button
          floated='right'
          title='Click or drag to add employee photo'
          style={{border: 'none', backgroundColor: "transparent"}}
          content={<EmployeePhotoDropzone email={employee.email} />}
        />
        }       
        <Card.Header textAlign='center'>
         <h1> {`${employee!.name}`}  
          {employee!.preferredName !== "" ? `  (${employee!.preferredName})` : ""} </h1>
        </Card.Header>
        <Card.Meta textAlign='center'><h2>{employee!.status}</h2></Card.Meta>
        <br/>
        <Card.Meta textAlign='center'>
          <span style={{fontWeight: 600, fontSize: 20, color: "black"}}> Email:</span>
          &nbsp;&nbsp; <span style={{fontSize: 20, color: "black"}}>{employee!.email}</span>

        </Card.Meta>
        <br/>
        <Card.Meta textAlign='center'>
        <span style={{fontWeight: 600, fontSize: 20, color: "black"}}>Mobile:</span>&nbsp;&nbsp; 
        <span style={{fontSize: 20, color: "black"}}>{employee!.mobile}</span>
          
        </Card.Meta>
        <br/>
        <Card.Meta textAlign='center'>
        <span style={{fontWeight: 600, fontSize: 18, color: "black"}}>Address:</span>&nbsp;&nbsp; 
        <span style={{fontSize: 20, color: "black"}}>{employee!.address}</span>
        </Card.Meta>
        <Table definition>
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>Company</Table.Cell>
              <Table.Cell>{employee!.company.toString()}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Department</Table.Cell>
              <Table.Cell>{employee!.department}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Position</Table.Cell>
              <Table.Cell>{employee!.position}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Project Type</Table.Cell>
              <Table.Cell>{employee!.projectType.toString()}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Date of Birth</Table.Cell>
              <Table.Cell>{employee!.dob}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Start Date</Table.Cell>
              <Table.Cell>{employee!.startDate}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Company Email</Table.Cell>
              <Table.Cell>{employee!.companyEmail}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Worker ID</Table.Cell>
              <Table.Cell>{employee!.workerId}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Employee Type</Table.Cell>
              <Table.Cell>{employee!.type}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Australian Residency</Table.Cell>
              <Table.Cell>{employee!.australianResidency}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>NBN Enable ID</Table.Cell>
              <Table.Cell>{employee!.nbnEnableId}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>USI</Table.Cell>
              <Table.Cell>{employee!.usi}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Remark</Table.Cell>
              <Table.Cell>{employee!.remark}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <br/>
        <Card.Header>
          <Grid>
          <GridColumn width='3'>
          <h2>Certificate</h2>
          </GridColumn>
          <GridColumn width='4'>
          <Button
            as={Link}
            to={`/hrmanagement/techniciancertificate-create/${employee.email}`}
            color="linkedin"
            icon="add"
            content="Create New"
          />
          </GridColumn>
          <GridColumn width='9'>
          <Button
            color="grey"
            icon="download"
            floated='right'
            content="Download"
            onClick={() => downloadEmployeeCertificateZipFile(employee.email, isCheck).then((url) => window.open(url))}
          />
          </GridColumn>
          </Grid>
        </Card.Header>
        {(employeenonecertificatesByName.length !== 0) && <Message warning>
          <Message.Header>Following certificates are missing:</Message.Header>
          <List bulleted>
          {employeenonecertificatesByName.map((cert) => (
            <List.Item>{cert.name}</List.Item>
          ))}
          </List>
        </Message>}
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={1}>
                <Checkbox 
                  label='All' 
                  onClick={handleSelectAll}
                  checked={isCheckAll}
                />
              </Table.HeaderCell>
              <Table.HeaderCell>Category</Table.HeaderCell>
              <Table.HeaderCell>Certificate</Table.HeaderCell>
              <Table.HeaderCell>Expiry Date</Table.HeaderCell>
              <Table.HeaderCell width={1}>Verified</Table.HeaderCell>
              <Table.HeaderCell>Remark</Table.HeaderCell>
              <Table.HeaderCell width={1}>Action</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {employeeCertificatesByDate.map((employeeCertificate) => (
              <Table.Row key={employeeCertificate.id}>
                <Table.Cell>
                   <Checkbox
                      checked={isCheck.includes(employeeCertificate.id)}
                      onClick={(e, data) => handleClick(employeeCertificate.id, data)}
                      name={employeeCertificate.id}
                  />
                </Table.Cell>
                <Table.Cell>
                  {
                    certificateRegistry.get(employeeCertificate.certificateId)
                      .category
                  }
                </Table.Cell>
                <Table.Cell>{employeeCertificate.certificate}</Table.Cell>
                {employeeCertificate.expiryDate < new Date().toISOString() ? (
                  <Table.Cell style={{ backgroundColor: "red" }}>
                    <Form.Input
                  name="expiryDate"
                  transparent
                  type='date'
                  onBlur={()=> editEmployeeCertificate(employeeCertificate)}
                  onChange={(e, {name, value})=> changeEmployeeCertificate(employeeCertificate, name, value)}
                  value={employeeCertificate.expiryDate}
                    />
                  </Table.Cell>
                ) : employeeCertificate.expiryDate <
                  new Date(
                    new Date().setMonth(new Date().getMonth() + 3)
                  ).toISOString() ? (
                  <Table.Cell style={{ backgroundColor: "yellow" }}>
                    <Form.Input
                  name="expiryDate"
                  transparent
                  type='date'
                  onBlur={()=> editEmployeeCertificate(employeeCertificate)}
                  onChange={(e, {name, value})=> changeEmployeeCertificate(employeeCertificate, name, value)}
                  value={employeeCertificate.expiryDate}
                    />
                  </Table.Cell>
                ) : (
                  <Table.Cell>
                    <Form.Input
                  name="expiryDate"
                  transparent
                  required
                  type='date'
                  onBlur={()=> editEmployeeCertificate(employeeCertificate)}
                  onChange={(e, {name, value})=> changeEmployeeCertificate(employeeCertificate, name, value)}
                  value={employeeCertificate.expiryDate}
                    />
                    </Table.Cell>
                )}
                <Table.Cell>
                { (employeeCertificate.verified === 'Y') ?  employeeCertificate.verified
                    : <Button
                        size='mini'
                        color="blue"
                        content="Verify"
                        onClick={() => verifyTechnicianCertificate(employeeCertificate.id).then(
                          () => checkCertificate())}
                        title={'This certificate was updated at ' + employeeCertificate.updatedAt.substr(0,19)}
                      />
                }
                </Table.Cell>
                <Table.Cell>{employeeCertificate.remark}</Table.Cell>
                <Table.Cell>
                <Button.Group size='mini'>
                <Button
                  as={Link}
                  to={`/hrmanagement/techniciancertificate-edit/${employeeCertificate.id}`}
                  size='mini'
                  icon="edit"
                  color="blue"
                  title="Edit"
                /> 
                <Button
                  name={employeeCertificate.id}
                  size='mini'
                  loading={target === employeeCertificate.id && submitting}
                  onClick={() => {
                    setOpen(true);
                    setTechnicianCertificateId(employeeCertificate.id);
                  }}
                  icon="delete"
                  color="red"
                  title="Delete"
                />
                <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteTechnicianCertificate(technicianCertificateId);
                        setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                  <Button
                  onClick={() => loadTechnicianCertificatePhoto(employeeCertificate.technicianEmail, employeeCertificate.certificateId).
                    then(() => openModal(<EmployeeCertificatePhotoView certificate={employeeCertificate.certificate} name={employeeCertificate.name}
                      technicianEmail={employeeCertificate.technicianEmail} certificateId={employeeCertificate.certificateId} />))}
                  size='mini'
                  icon="picture"
                  color="green"
                  title="Photo"
                />
                  <CertificatePhotoDropzone name={employeeCertificate.certificate} category={employeeCertificate.name}/>                 
          </Button.Group>
        </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Card.Content>

      <Card.Content extra>
        <Button.Group widths={2}>
          <Button
            as={Link}
            to={`/hrmanagement/employees-edit/${employee.email}`}
            basic
            color="blue"
            content="Edit"
          />
          <Button
            onClick={() => history.push("/hrmanagement/employees")}
            basic
            color="grey"
            content="Cancel"
          />
        </Button.Group>
      </Card.Content>
    </Card>
  );
};

export default observer(EmployeeDetails);
